import {createAction, props} from '@ngrx/store';

export const loadQualifyingCatalogIds = createAction(
  '[Catalog] Load qualifying catalog ids',
);

export const loadQualifyingCatalogIdsSuccess = createAction(
  '[Catalog] Load qualifying catalog ids success',
  props<{catalogIds: string[]}>(),
);

export const removeCatalogId = createAction(
  '[Catalog] Remove catalog id',
  props<{catalogId: string}>(),
);

export const loadCatalogsFailure = createAction(
  '[Catalog] Load Catalogs Failure',
  props<{error: Error}>(),
);
